import React from 'react';
import './Loading.css';

const Loading = ({ message }) => {
  return (
    <div className="loading-container">
      <div className="loading-logo">
        <span className="loading-logo-icon">⚡</span>
        <h1>
          minus<span className="loading-logo-number loading-logo-number-1">1</span>to<span className="loading-logo-number loading-logo-number-0">0</span>
        </h1>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default Loading;

